import FrontendLayout from "../layouts/Frontend/FrontendLayout";
import Shop from "../layouts/Frontend/Pharmacy/Shop";
import PharmacyList from "../layouts/Frontend/Pharmacy/PharmacyList";
import PharmacyDetailes from "../layouts/Frontend/Pharmacy/PharmacyDetailes";

const pharmacyMacRoutes = [
  { path: "/pharmacy-mac/dashboard", element: <FrontendLayout><Shop/></FrontendLayout> },
  { path: "/pharmacy-mac/list", element: <FrontendLayout><PharmacyList/></FrontendLayout> },
  { path: "/pharmacy-mac/detailes", element: <FrontendLayout><PharmacyDetailes/></FrontendLayout> },
];

export default pharmacyMacRoutes;
